import PropTypes from "prop-types";
import styles from "./PopInner.module.scss";
import OnboardingLogo from "../../../../assets/onboarding.svg";

const PopupInner = ({ skip, showExpressTour, componentRef }) => {
  return (
    <div className={styles.onboardingPopupInner} ref={componentRef}>
      <img src={OnboardingLogo} alt="Bet Builder Onboarding Logo" />
      <div className={styles.onboardingPopupTitle}>
        Welcome to <br />
        the mix ‘n match!
      </div>
      <div className={styles.onboardingPopupDescription}>
        Our new one-stop betting hub, so you don&apos;t have to jump around. And
        we&apos;ve thrown in some cool stats to make your bets even more fun!
      </div>
      <div className={styles.onboardingPopupContainerButtons}>
        <button
          className={styles.onboardingPopupContainerButton}
          type="button"
          onClick={showExpressTour}
        >
          Hop on the express tour
        </button>
        <button
          className={styles.onboardingPopupContainerButton}
          type="button"
          onClick={skip}
        >
          Skip tour
        </button>
      </div>
    </div>
  );
};

PopupInner.propTypes = {
  skip: PropTypes.func,
  showExpressTour: PropTypes.func,
  componentRef: PropTypes.object,
};

export default PopupInner;
